<rs-web-image [defaultSrc]="'/web/images/png/waiting.png'"></rs-web-image>
<h1 class="text-center" [innerHTML]="'no_tickets_catalogue_info.title_l' | translate"></h1>
<p class="text-center" [innerHTML]="'no_tickets_catalogue_info.description_l' | translate"></p>
